import { useEffect } from 'react';

const Seo = () => {
  const siteUrl = 'https://nextcore-ict.com';
  const title = 'Next Core ICT Solutions — Smart ICT for growing Philippine businesses.';
  const description =
    'Next Core ICT Solutions delivers fast, secure, and scalable ICT systems, web platforms, and dashboards for businesses, schools, and SMEs across the Philippines.';

  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    updateMetaTag('description', description);
    updateMetaTag('keywords', 'web development, custom software, POS systems, inventory management, website development, portfolio websites, Philippines, ICT solutions');
    updateMetaTag('author', 'Next Core ICT Solutions');
    updateMetaTag('robots', 'index, follow');
    updateMetaTag('og:type', 'website', true);
    updateMetaTag('og:url', siteUrl, true);
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', `${siteUrl}/new_logo/logo.png`, true);
    updateMetaTag('og:site_name', 'Next Core ICT Solutions', true);
    updateMetaTag('og:locale', 'en_US', true);
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:url', siteUrl);
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', `${siteUrl}/new_logo/logo.png`);
    updateMetaTag('theme-color', '#0F2236');
    updateMetaTag('msapplication-TileColor', '#0F2236');
  }, [title, description, siteUrl]);

  return null;
};

export default Seo;
